"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatsDisplay = void 0;
var React = require("react");
var TaskStatsStore = require("../store/TaskStats");
var react_redux_1 = require("react-redux");
var TaskStatsDisplay = /** @class */ (function (_super) {
    __extends(TaskStatsDisplay, _super);
    function TaskStatsDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TaskStatsDisplay.prototype.componentDidMount = function () {
        this.props.startAdminTaskUpdates();
    };
    TaskStatsDisplay.prototype.beautifyMs = function (ms) {
        if (ms < 0)
            return '-';
        if (ms < 3600000)
            return Math.round(ms / 60000) + " m";
        return Math.round(ms / 3600000) + " h";
    };
    TaskStatsDisplay.prototype.render = function () {
        var _this = this;
        if (!this.props.tasks)
            return (React.createElement(React.Fragment, null, "Loading..."));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { position: 'absolute', top: '1%', left: '0', width: '100%' } },
                React.createElement("table", { className: "table table-dark table-striped mx-auto", style: { width: '99%' } },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col" }, "Task"),
                            React.createElement("th", { scope: "col" }, "Ended"),
                            React.createElement("th", { scope: "col" }),
                            React.createElement("th", { scope: "col" }, "Puppet"),
                            React.createElement("th", { scope: "col" }, "Puppeteer"),
                            React.createElement("th", { scope: "col" }, "Video (kbps)"),
                            React.createElement("th", { scope: "col" }, "Audio (kbps)"),
                            React.createElement("th", { scope: "col" }, "Web delay (ms)"),
                            React.createElement("th", { scope: "col" }, "Server delay (ms)"),
                            React.createElement("th", { scope: "col" }, "Control delay (ms)"),
                            React.createElement("th", { scope: "col" }, "Accuracy"),
                            React.createElement("th", { scope: "col" }, "Performance"),
                            React.createElement("th", { scope: "col" }, "Satisfaction"))),
                    React.createElement("tbody", null, this.props.tasks.map(function (taskState, index) {
                        return (React.createElement("tr", { key: taskState.Guid, className: "" + (taskState.End ? "" : "bg-info") },
                            React.createElement("th", { scope: "row" },
                                taskState.Description.substr(0, 50),
                                "..."),
                            React.createElement("td", null, taskState.End ? "" + _this.beautifyMs(Date.now() - Date.parse(taskState.End.toString())) : null),
                            React.createElement("td", null, taskState.Updating ? React.createElement("span", null, "\u26A1") : null),
                            React.createElement("td", null, taskState.PuppetCustomerUsername),
                            React.createElement("td", null, taskState.PuppeteerCustomerUsername),
                            React.createElement("td", null, taskState.VideoRate ? Math.round(taskState.VideoRate * 8 / 1000) : taskState.End ? '' : '---'),
                            React.createElement("td", null, taskState.AudioRate ? Math.round(taskState.AudioRate * 8 / 1000) : taskState.End ? '' : '---'),
                            React.createElement("td", { className: taskState.MovementClientToController > 500 ? 'text-warning' : '' }, taskState.MovementClientToController > 0 ? Math.round(taskState.MovementClientToController) : '-'),
                            React.createElement("td", { className: taskState.MovementControllerToRcs > 20 ? 'text-warning' : '' }, Math.round(taskState.MovementControllerToRcs)),
                            React.createElement("td", { className: taskState.MovementRcsToClient > 50 ? 'text-warning' : '' }, Math.round(taskState.MovementRcsToClient)),
                            React.createElement("td", null, taskState.AccuracyRating),
                            React.createElement("td", null, taskState.PerformanceRating),
                            React.createElement("td", null, taskState.SatisfactionRating)));
                    }))),
                React.createElement("div", { className: "clearfix" }))));
    };
    return TaskStatsDisplay;
}(React.PureComponent));
exports.TaskStatsDisplay = TaskStatsDisplay;
exports.default = react_redux_1.connect(function (state) { return state.taskStats; }, TaskStatsStore.actionCreators)(TaskStatsDisplay);
//# sourceMappingURL=Stats.js.map